import { useState, useEffect } from 'react';
import axios from 'axios';

const useFetchConstructionPricing = () => {
  const [transposedData, setTransposedData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPricing = async () => {
      try {
        const response = await axios.get('/api/PipelinePricing/construction/all-pricing');
        const rawData = response.data || [];

        // Extract unique pipe sizes
        const pipeSizes = [...new Set(rawData.map((d) => d.pipeSize?.toString()))]
          .filter(Boolean)
          .sort((a, b) => parseFloat(a) - parseFloat(b));

        // Extract unique categories
        const categories = [...new Set(rawData.map((d) => d.category?.trim()))];

        // Build rows
        const rows = categories.map((category) => {
          const row = { category };

          pipeSizes.forEach((size) => {
            const match = rawData.find((d) => {
              const dataCategory = d.category?.trim();
              const dataSize = d.pipeSize?.toString();
              return dataCategory === category && dataSize === size;
            });

            // Attach id + price in each cell
            row[size] = match
              ? {
                  id: match.id,
                  price: match.price != null && !isNaN(match.price) ? Number(match.price) : ''
                }
              : { id: null, price: '' };
          });

          return row;
        });

        // Build column definitions
        const columns = [
          {
            headerName: 'Category',
            field: 'category',
            pinned: 'left',
            flex: 2,
            cellStyle: { fontWeight: 'bold', backgroundColor: '#f9f9f9' },
          },
          ...pipeSizes.map((size) => ({
            headerName: `${size}"`,
            field: size.toString(),
            editable: true,
            flex: 1,
            valueGetter: (params) => {
              const cell = params.data[size];
              return cell ? cell.price : '';
            },
            valueSetter: (params) => {
              const cell = params.data[size];
              if (cell) {
                cell.price = Number(params.newValue);
              }
              return true;
            },
            valueFormatter: ({ value }) =>
              value === '' || value === null || isNaN(Number(value))
                ? ''
                : Number(value).toLocaleString(),
          })),
        ];

        setTransposedData(rows);
        setColumnDefs(columns);
      } catch (err) {
        setError(err);
        console.error('Failed to fetch:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPricing();
  }, []);

  return { transposedData, columnDefs, loading, error };
};

export default useFetchConstructionPricing;
